import { createDomain, sample } from 'effector'
import { AggregatorDriver, AxiosErrorType } from '~/shared/api'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain('driver.aggregators.changeAggregatorDriverModal')

export const setMainFx = domain.createEffect<
  {
    aggregatorDriverId: UniqueId
  },
  void,
  AxiosErrorType
>({
  handler: async ({ aggregatorDriverId }) => {
    await AggregatorDriver.setMain(aggregatorDriverId)
  },
})

sample({
  clock: setMainFx.doneData,
  fn() {
    return {
      messageI18n: 'alert.aggregator switched' as const,
      variant: 'success' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: setMainFx.failData,
  fn(e) {
    return {
      message: mapMessageErrors(e),
      variant: 'error' as const,
    }
  },
  target: snackbarEnqueued,
})
